import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Button({ children, variant = 'primary', size = 'md', onClick, href, className = '', icon, type = 'button', ...props }) {
  const sizes = {
    sm: 'px-5 py-2.5 text-sm',
    md: 'px-6 py-3 text-base lg:px-8 lg:py-3.5',
    lg: 'px-8 py-4 text-base lg:px-10 lg:py-4.5 lg:text-lg',
  };

  const base = `inline-flex items-center justify-center gap-2 font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer ${sizes[size]} ${className}`;

  const variants = {
    primary: 'btn-primary focus:ring-yellow-500',
    outline: 'btn-outline focus:ring-yellow-500',
    ghost: 'text-white border border-white/30 hover:bg-white/10 focus:ring-white',
    dark: 'bg-[var(--color-primary)] text-white hover:bg-[var(--color-primary-light)] focus:ring-blue-500',
  };

  const cls = `${base} ${variants[variant]}`;

  const content = (
    <>
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </>
  );

  if (href) {
    const isExternal = href.startsWith('http') || href.startsWith('//') || href.startsWith('mailto') || href.startsWith('tel');
    if (isExternal) {
      return (
        <motion.a href={href} className={cls} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} target="_blank" rel="noopener noreferrer" {...props}>
          {content}
        </motion.a>
      );
    }
    return (
      <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} style={{ display: 'inline-flex' }}>
        <Link to={href} className={cls} {...props}>
          {content}
        </Link>
      </motion.div>
    );
  }

  return (
    <motion.button type={type} onClick={onClick} className={cls} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} {...props}>
      {content}
    </motion.button>
  );
}
